import { CampaignAgentPhones_campaign_agentPhones } from 'types/apollo/CampaignAgentPhones';
import { AgentPhoneStatus } from 'types/apollo/globalTypes';
import { Data } from './agent-phones';

export type FilterStatus = AgentPhoneStatus | 'ALL';

interface Filters {
  search?: string;
  status?: string;
}

export function formatAgentPhone(agentPhone: CampaignAgentPhones_campaign_agentPhones): Data {
  return {
    id: `${agentPhone.phone}`,
    locality: agentPhone.locality,
    messagingServiceId: agentPhone.messagingServiceId,
    phone: agentPhone.phone,
    region: agentPhone.region,
    status: agentPhone.status,
  };
}

export const applyFilter = (
  { search, status }: Filters,
  agentPhones: CampaignAgentPhones_campaign_agentPhones[],
): Data[] => {
  let tableRows: Data[] = [];
  agentPhones.forEach((agentPhone) => {
    tableRows.push(formatAgentPhone(agentPhone));
  });

  if (search) {
    const lowerSearch = search.toLowerCase();
    tableRows = tableRows.filter(
      (agentPhone) =>
        agentPhone.phone.toLowerCase().includes(lowerSearch) ||
        agentPhone.locality.toLowerCase().includes(lowerSearch) ||
        agentPhone.region.toLowerCase().includes(lowerSearch),
    );
  }
  if (status !== 'ALL') {
    tableRows = tableRows.filter((agentPhone) => agentPhone.status === status);
  }

  return tableRows;
};
